import api from "@/services";
import utils from "@/services/utils";

const state = {
  formContent: {
    textFirstView: "",
    textWarningBalloon: "",
    textSecondView: "",
    textForNonCustom:
      "<h3>CONFIRA ABAIXO OS PREÇOS E PRAZOS PARA SEU PROJETO!</h3>" +
      "Muito obrigado por escolher a Audiotext, [username]." +
      "Para [amount] minutos de transcrição, confira abaixo os preços e prazos para seu projeto. Qual opção atende melhor às suas necesssidades?" +
      "<strong>Clique em 'enviar arquivos' e nos indique a opção de preço prazo que te atende melhor.</strong>" +
      "Este orçamento também foi enviado para seu e-mail. Verifique sua caixa de spam, caso não encontre em sua caixa de entrada.",
    textForCustom:
      "As especificações que você nos informou necessitam de uma proposta customizada, em breve uma pessoa de nossa equipe entrará em contato",
    textForNotFound: "Nenhuma proposta disponível para este orçamento.",
    textLinkWhatsapp:
      "https://api.whatsapp.com/send?phone=5541997990622&text=Ol%C3%A1!%20Tenho%20uma%20d%C3%BAvida%20sobre%20meu%20or%C3%A7amento%2C%20voc%C3%AA%20pode%20me%20ajudar%3F%20",
    textlinkSendFiles: "https://audiotext.wetransfer.com"
  }
};

const mutations = {
  FETCH_FORM_CONTENT(state, data) {
    state.formContent.textFirstView = data.textFirstView;
    state.formContent.textWarningBalloon = data.textWarningBalloon;
    state.formContent.textSecondView = data.textSecondView;
    state.formContent.textLinkWhatsapp = data.textLinkWhatsapp;
    state.formContent.textlinkSendFiles = data.textlinkSendFiles;
    state.formContent.textForNonCustom = data.textForNonCustom
      ? data.textForNonCustom
      : state.formContent.textForNonCustom;
    state.formContent.textForCustom = data.textForCustom
      ? data.textForCustom
      : state.formContent.textForCustom;
    state.formContent.textForNotFound = data.textForNotFound
      ? data.textForNotFound
      : state.formContent.textForNotFound;
  }
};

const actions = {
  async fetchContentForm({ commit }, query) {
    const response = await utils.request(api.form.getContentForm(query));
    if (response && response.status === 200) {
      const { data } = response;
      commit("FETCH_FORM_CONTENT", data);
    }
    return response;
  },
  async patchContentForm({ commit }, data) {
    const response = await utils.request(api.form.updateContentForm(data));
    if (response && response.status === 200) {
      return response;
    }
    console.error(response);
    return null;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/editTemplateForm.js